<template>
  <div id="app" @click="handleClose">
    <Header :isClose='close' />  <!-- 头部 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <Footer /> <!-- 底部 -->
   <Gotop :showQrcode="pathName=='detail'" :type="type"/>
  </div>
</template>

<script>
import Footer from "@/components/common/footer.vue"; // 底部组件
import Header from "@/components/common/header.vue"; // 头部组件
import Gotop from "@/components/common/goTop.vue"; 
export default {
  name: "App",
  components: {
    Footer,
    Header,
    Gotop
  },
  data(){
    return{
      close:false
    }
  },
  computed:{
    pathName() {
      return this.$route.name;
    },
    type(){
      return this.$route.query.type;
    }
  },
  methods:{
     handleClose(){
      this.close = !this.close
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
#app{
  
  
  background: #ffffff;


}
ul li{
  cursor: pointer;
  list-style-type: none;
}
img{
  user-select: none; 
  /* 去除选中蓝色 */
}
</style>
